import React, { useEffect } from 'react';
import paginationFactory from 'react-bootstrap-table2-paginator';
import useServerTable from '../../libs/useServerTable';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css';

const columns = [
    {
        dataField: 'login',
        text: 'Логин',
        sort: true,
        filter: textFilter({
            placeholder: 'Поиск по логину...'
        })
    },
    {
        dataField: 'name',
        text: 'ФИО',
        sort: true,
        filter: textFilter({
            placeholder: 'Поиск по ФИО...'
        })
    },
    {
        dataField: 'access',
        text: 'Роль',
        sort: true,
        filter: textFilter({
            placeholder: 'Поиск по роли...'
        })
    },
    {
        dataField: 'userSource.source',
        text: 'Источник',
        sort: true,
        filter: textFilter({
            placeholder: 'Поиск по источнику...'
        })
    }
];

const tableStyle = {
    width: '100%',
    tableLayout: 'fixed'
};

const BaseUserTable = ({ kind = 'users', revision = 0, additionalColumns = [] }) => {
    const table = useServerTable(kind, {}, {}, 'login', 'asc');
    useEffect(() => { table.reload(); }, [revision]);
    let fullColumns = [...columns, ...additionalColumns];

    return (
        <div>
        {table.error && <p role="alert">{table.error} <button onClick={table.reload}>Повторить</button></p>}
        {table.loading && <p role="status">Загрузка...</p>}
        <BootstrapTable
            remote={{ pagination: true, filter: true, sort: true }}
            onTableChange={table.onTableChange}
            pagination={paginationFactory({ page: table.page, sizePerPage: table.limit, totalSize: table.total, sizePerPageList: [10, 25, 50, 100], showTotal: true })}
            striped
            hover
            keyField='_id'
            data={table.rows}
            columns={fullColumns}
            tableStyle={tableStyle}
            filter={filterFactory()}
            defaultSorted={[{ dataField: "login", order: "asc" }]}
            defaultSortOrder="asc"
        />
        </div>
    );
};

export default BaseUserTable;